import { Helmet } from 'react-helmet-async';

import PassResetConfirmForm from '../components/passResetConfirmForm';
import { DOMAIN_NAME } from '../config/api';

const PassResetConfirmPage = () => (
  <div className="login flex flex-col items-center justify-center flex-grow p-4">
    <Helmet>
      <title>Новый пароль | {DOMAIN_NAME}</title>
    </Helmet>
    <PassResetConfirmForm />
  </div>
);

export default PassResetConfirmPage;
